"use client";

import { FaFacebook, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import {
    LuCheckCircle,
    LuCheckCircle2,
    LuClipboard,
    LuCopy,
    LuExternalLink,
    LuQrCode,
} from "react-icons/lu";
import Modal from "../themed/Modal";
import { useState } from "react";
import Image from "next/image";
import { APP_URL } from "~/utils/constants";
import { toast } from "react-toastify";
import { cn } from "~/utils/fontsConfig";
import { TbCopy, TbCopyCheck } from "react-icons/tb";
import Link from "next/link";

const ShareEventLinks = ({
    event,
}: {
    event: { id: string; slug: string };
}) => {
    const [hasCopied, setHasCopied] = useState(false);
    const [isQrModalOpen, setIsQrModalOpen] = useState(false);
    const link = `${APP_URL}/e/${event.id.slice(-12)}`;

    const copyLinkToClipboard = () => {
        navigator.clipboard.writeText(link);
        setHasCopied(true);
        toast.success("Link copied to clipboard");
        setTimeout(() => setHasCopied(false), 2000);
    };

    return (
        <>
            <div className="flex w-full justify-between text-v3-N-300">
                <div className="w-max ">Share event</div>
                <div className="flex items-center gap-2">
                    <LuQrCode
                        onClick={() => setIsQrModalOpen(true)}
                        className="cursor-pointer hover:text-white"
                    />

                    <span
                        className="relative h-4 w-4 cursor-pointer hover:text-white"
                        onClick={copyLinkToClipboard}
                    >
                        <TbCopy
                            className={cn(
                                "absolute  transition-opacity duration-200 ease-in-out",
                                hasCopied && "opacity-0",
                            )}
                        />
                        <TbCopyCheck
                            className={cn(
                                "absolute text-v3-primary opacity-0 transition-opacity duration-300 ease-in-out",
                                hasCopied && "opacity-100",
                            )}
                        />
                    </span>

                    {/* <FaFacebook />
                    <FaXTwitter />
                    <FaLinkedin /> */}
                </div>
            </div>
            <Modal
                open={isQrModalOpen}
                onOpenChange={setIsQrModalOpen}
                title="Share event"
                description="Your friends can scan this QR code to join your event"
                className="w-[450px]"
            >
                <Link href={link} target="_blank">
                    <div className="flex flex-col items-center justify-center gap-4">
                        <Image
                            src={`${APP_URL}/api/og/invite/${event.id}`}
                            alt="QR Code"
                            width={256}
                            height={256}
                            priority
                        />
                    </div>
                </Link>
                <Link
                    className="group mt-2 flex w-full cursor-pointer items-center justify-center text-v3-N-300 hover:text-white"
                    href={link}
                    target="_blank"
                >
                    <div className="flex items-center gap-2">
                        <span className="text-sm">{link}</span>
                        <LuExternalLink className="text-v3-N-300 group-hover:text-white" />
                    </div>
                </Link>
            </Modal>
        </>
    );
};

export default ShareEventLinks;
